import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {AnalyticsService} from '@irb-common/analytics/analytics.service';
import {Router} from '@angular/router';

@Injectable({
    providedIn: "root"
})
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        private ats: AnalyticsService
    ) {
    }

    handleError(error: any) {
        const url = window.location.hostname;
        let isLocal = false;
        if (url)
            isLocal = url.indexOf('localhost') !== -1;

        let errorSummary: any = {}, statArray = [];
        if ((error.originFrom === 'error-interceptor')) {
            errorSummary.errorstatus = error.status;
            errorSummary.errormessage = error.message;//.replace(/"/g, '`');

            statArray.push(error.status);
            statArray.push(error.message);
            if (isLocal)
                console.error(error);
            else
                this.ats.trackErrors(statArray);
        } else {
            if (error && error.message) {
                errorSummary.errormessage = error.message;//.replace(/"/g, '`');
                statArray.push(error.message);
                // if (error.stack) {
                //     let stack = error.stack.replace(error.message, '');
                //     stack = stack.toString().substring(0, (450-error.message.length));//.replace(/"/g, '`');
                //     statArray.push(stack);
                // }
                if (isLocal)
                    console.error(error);
                else
                    this.ats.trackErrors(statArray);
            }
        }

    }
}
